import { render, staticRenderFns } from "./BookingTimeSlots.vue?vue&type=template&id=52e08dda&scoped=true&"
import script from "./BookingTimeSlots.vue?vue&type=script&lang=js&"
export * from "./BookingTimeSlots.vue?vue&type=script&lang=js&"
import style0 from "./BookingTimeSlots.vue?vue&type=style&index=0&id=52e08dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e08dda",
  null
  
)

export default component.exports